import { render } from "./CxDynamicList.vue?vue&type=template&id=761ae1be"
import script from "./CxDynamicList.vue?vue&type=script&lang=js"
export * from "./CxDynamicList.vue?vue&type=script&lang=js"

import "./CxDynamicList.vue?vue&type=style&index=0&id=761ae1be&lang=less"

import exportComponent from "/home/ec2-user/workspace/_conx-ui-monorepo_ui2_lab_master/apps/ui2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__